import React, { useEffect, useState } from "react";
import bm from "../100-board-members/BoardMembers100.module.scss";
import Styles from "./ImpactMain.module.scss";
import { urls } from "../../utils/urls";
import { appLevelConstants } from "../../constants/AppLevelConstants";

export default function ImpactMain() {
  const [profession, setProfession] = useState("CEOs");

  const getNextProfession = (currentProfession) => {
    switch (currentProfession) {
      case "CEOs":
        return "CHRO";
      case "CHRO":
        return "COOs";
      case "COOs":
        return "CFOs";
      case "CFOs":
        return "CTOs";
      case "CTOs":
        return "CxOs";
      case "CxOs":
        return "CEOs";
      default:
        return "CEOs";
    }
  };

  useEffect(() => {
    const toggleInterval = setInterval(() => {
      setProfession((prev) => getNextProfession(prev));
    }, 2000);
    return () => clearInterval(toggleInterval);
  }, []);

  const scrollToStories = () => {
    document.getElementById("success-stories")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <section className={bm.hero}>
        <div
          className={bm["hero-bg-image"]}
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ""}/impact-hero.jpeg)` }}
          aria-hidden
        />
        <div className={bm["hero-overlay"]} />
        <div className={Styles.impactHeroVeil} aria-hidden />
        <div className={bm["hero-inner"]}>
          <div className={bm["hero-content"]}>
            <div className={bm["hero-eyebrow"]}>Stories &amp; scale</div>
            <div className={bm["hero-brand"]}>Impact</div>
            <div className={bm["hero-tagline"]}>
              Leadership
              <span>that compounds.</span>
            </div>
            <p className={bm["hero-sub"]}>
              Meet the women who moved from capability to command — and explore how Iron Lady programs show up in real careers and real results.
            </p>
            <div className={bm["hero-cta"]}>
              <div className={bm["hero-cta-group"]}>
                <button type="button" className={bm["btn-primary"]} onClick={scrollToStories}>
                  <span>Explore success stories</span> →
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={bm["video-section"]} aria-label="Impact overview video">
        <div className={bm["video-wrap"]}>
          <video
            className={Styles["impact-hero-video"]}
            controls
            playsInline
            poster={urls.impactThumbneil}
          >
            <source src={urls.impactVideo} type="video/mp4" />
          </video>
        </div>
      </section>

      <section className={`${bm.authority} ${Styles["impact-authority"]}`}>
        <div className={`${bm["authority-grid"]} ${Styles["impact-authority-grid"]}`}>
          <div className={`${bm["authority-left"]} ${Styles["impact-authority-left"]}`}>
            <span className={`${bm.eyebrow} ${Styles["impact-eyebrow"]}`}>At scale</span>
            <h2 className={Styles["impact-authority-heading"]}>
              Programs that reach
              <br />
              <span className={bm["blink-wrap"]}>
                <span className={bm["blink-word"]}>leaders.</span>
                <span className={bm["blink-word"]}>teams.</span>
                <span className={bm["blink-word"]}>organizations.</span>
              </span>
            </h2>
            <p className={Styles["impact-authority-body"]}>
              Iron Lady is built for women who are done waiting for permission — and ready for outcomes the business can see.
            </p>
            <p className={`${bm["authority-coda"]} ${Styles["impact-authority-coda"]}`}>The numbers follow the work.</p>
          </div>
          <div className={`${bm["authority-right"]} ${Styles["impact-authority-right"]}`}>
            <div className={Styles["impact-stats-box"]}>
              <div className={Styles["impact-stat-block"]}>
                <p className={`${Styles["impact-stats-line"]} ${Styles["impact-stats-primary"]}`}>
                  {appLevelConstants.impact.impactTitle1}
                </p>
              </div>
              <div className={Styles["impact-stats-divider"]} aria-hidden="true" />
              <div className={Styles["impact-stat-block"]}>
                <p className={Styles["impact-stats-line"]}>
                  {appLevelConstants.impact.impactTitle2}{" "}
                  <span className={Styles.profession}>{profession}</span>{" "}
                  {appLevelConstants.impact.impactTitle3}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
